import {findAllIn, findIn, on} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import {getApi} from "@elements/form-validation";

export function init() {
    onFind('.js-one-input-required', function (baseElement) {

        getApi(baseElement).then((formApi) => {
            let formInstance = formApi.getFormInstance();

            // formInstance.fields += {
            //    requiredInputGroup: {
            //        selector: '.js-one-input-required__group',
            //        validators: {
            //            requestOneInputInGroup: requestOneInputInGroup,
            //        }
            //    }
            // }
            //
            // const requestOneInputInGroup = function () {
            //     return {
            //         validate: function (validationGroup) {
            //             let inputs = findAllIn('input', validationGroup);
            //             inputs.map(function (input) {
            //                 if (input.type === 'radio' || input.type === 'checkbox') {
            //                     let checked = input.checked;
            //                     if (checked === true)  {
            //                         return {
            //                             valid: true,
            //                         };
            //                     } else return {valid: false};
            //                 }
            //                 else {
            //                     let value = input.value;
            //                     if (value !== '')  {
            //                         return {
            //                             valid: true,
            //                         };
            //                     } else return {valid: false};
            //                 }
            //             });
            //         },
            //     };
            // };
            //
            //
            // let validationGroups = findAllIn('.js-one-input-required__group', baseElement);
            // validationGroups.map(function (validationGroup) {
            //     on('change', function (event) {
            //         let isValid = requestOneInputInGroup().validate(validationGroup);
            //         console.log(isValid);
            //     }, validationGroup);
            // });

        });
    });
}
